/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationEventTemplateVariables } from '../models/ApplicationEventTemplateVariables';
import type { ApplicationEventType } from '../models/ApplicationEventType';
import type { Country } from '../models/Country';
import type { CustomFieldDefinition } from '../models/CustomFieldDefinition';
import type { ExternalIdentityProvider } from '../models/ExternalIdentityProvider';
import type { Language } from '../models/Language';
import type { MtLanguage } from '../models/MtLanguage';
import type { MtServiceProvider } from '../models/MtServiceProvider';
import type { PowerBiReportSummary } from '../models/PowerBiReportSummary';
import type { PowerBiWorkspace } from '../models/PowerBiWorkspace';
import type { PresignedPost } from '../models/PresignedPost';
import type { Province } from '../models/Province';
import type { Xl8Language } from '../models/Xl8Language';
import type { Xl8ServiceProvider } from '../models/Xl8ServiceProvider';
import type { XtrfService } from '../models/XtrfService';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UtilsService {
    /**
     * Returns a list of all XTRF services (workflows)
     * @returns XtrfService successful operation
     * @throws ApiError
     */
    public static listXtrfServices(): CancelablePromise<Array<XtrfService>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/xtrfServices',
        });
    }
    /**
     * Returns a list of all identity providers configured in Cognito
     * @returns ExternalIdentityProvider successful operation
     * @throws ApiError
     */
    public static listExternalIdentityProviders(): CancelablePromise<Array<ExternalIdentityProvider>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/externalIdentityProviders',
        });
    }
    /**
     * Returns a list of XTRF view filters
     * @returns CustomFieldDefinition successful operation
     * @throws ApiError
     */
    public static listXtrfViewFilters({
        viewId,
    }: {
        /**
         * xtrf view identifier
         */
        viewId: number,
    }): CancelablePromise<Array<CustomFieldDefinition>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/xtrfViewFilters/{viewId}',
            path: {
                'viewId': viewId,
            },
        });
    }
    /**
     * Returns a list of all active languages
     * @returns Language successful operation
     * @throws ApiError
     */
    public static listLanguages(): CancelablePromise<Array<Language>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/languages',
        });
    }
    /**
     * Returns a list of all active countries
     * @returns Country successful operation
     * @throws ApiError
     */
    public static listCountries(): CancelablePromise<Array<Country>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/countries',
        });
    }
    /**
     * Returns a list of all active provinces
     * @returns Province successful operation
     * @throws ApiError
     */
    public static listProvinces(): CancelablePromise<Array<Province>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/provinces',
        });
    }
    /**
     * Returns the variables available for use in notification templates for the given application event type
     * @returns ApplicationEventTemplateVariables successful operation
     * @throws ApiError
     */
    public static getApplicationEventTemplateVariables({
        eventType,
    }: {
        /**
         * Application event type
         */
        eventType: ApplicationEventType,
    }): CancelablePromise<ApplicationEventTemplateVariables> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/applicationEventTemplateVariables/{eventType}',
            path: {
                'eventType': eventType,
            },
        });
    }
    /**
     * Creates a presigned URL for uploading files to temp S3 bucket
     * @returns PresignedPost successful operation
     * @throws ApiError
     */
    public static createFileUploadPresignedPost(): CancelablePromise<PresignedPost> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/utils/tempFiles/actions/createPresignedPost',
        });
    }
    /**
     * Returns a list of all languages available for machine translation provider
     * @returns MtLanguage successful operation
     * @throws ApiError
     */
    public static listMachineTranslationLanguages({
        provider,
    }: {
        provider: MtServiceProvider,
    }): CancelablePromise<Array<MtLanguage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/mtLanguages',
            query: {
                'provider': provider,
            },
        });
    }
    /**
     * Returns a list of all languages available for xl8 provider
     * @returns Xl8Language successful operation
     * @throws ApiError
     */
    public static listXl8Languages({
        provider,
    }: {
        provider: Xl8ServiceProvider,
    }): CancelablePromise<Array<Xl8Language>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/xl8Languages',
            query: {
                'provider': provider,
            },
        });
    }
    /**
     * Returns a list of PowerBI reports from a workspace using configured credentials
     * @returns PowerBiReportSummary successful operation
     * @throws ApiError
     */
    public static listPowerBiReports({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<Array<PowerBiReportSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/powerBiReports',
            query: {
                'workspaceId': workspaceId,
            },
        });
    }
    /**
     * Returns a list of PowerBI workspaces using configured credentials
     * @returns PowerBiWorkspace successful operation
     * @throws ApiError
     */
    public static listPowerBiWorkspaces(): CancelablePromise<Array<PowerBiWorkspace>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/utils/powerBiWorkspaces',
        });
    }
}
